<ul class="nav navbar-nav top-nav-bg nav-open">
    @if (routeNavId !== rootNavId) {
        <li>
            <a
                class="d-block"
                href="#"
                (click)="clickDropdown(routeNavId, true)"
            >
                <img
                    class="back-svg"
                    src="assets/images/navigation/Back.svg"
                />
                Back
            </a>
        </li>
    }
    @for (route of loopNavRoutes; track route) {
        @if (
            route.ellipseBefore &&
            !navService.shouldShowRouteLink(route, navRoutes, route.index) &&
            !navService.shouldShowRouteLink(
                navRoutes[route.index - 1],
                navRoutes,
                route.index
            )
        ) {
            <li class="ellipse">...</li>
        }
        @if (
            route.ellipseBefore ||
            route.ellipseAfter ||
            navService.shouldShowRouteLink(route, navRoutes)
        ) {
            <li
                #linkLi
                [class.link-active]="forceSelect === route.id"
                [routerLinkActive]="['link-active']"
                [routerLinkActiveOptions]="{ exact: route.exact }"
            >
                <a
                    class="d-block"
                    [routerLink]="[route.path]"
                    [queryParams]="route.queryParams"
                >
                    {{ route.name }}
                </a>
            </li>
        }
        @if (
            route.ellipseAfter &&
            !navService.shouldShowRouteLink(route, navRoutes) &&
            !navService.shouldShowRouteLink(
                navRoutes[route.index + 1],
                navRoutes
            )
        ) {
            <li class="ellipse">...</li>
        }
        @if (route && route.children && !route.hasSideNav) {
            <li class="dropdown">
                <a
                    class="d-block dropdown-toggle"
                    href="#"
                    (click)="clickDropdown(route.id)"
                >
                    {{ route.name }}
                </a>
            </li>
        }
    }
</ul>
